export enum RpaStatus {
    Pending = 'Pending',
    Successful = 'Successful',
    Failed = 'Failed',
    Reversed = 'Reversed',
    Cancelled = 'Cancelled'
}
